<div class="notification-popup" >
  <div class="notification-header">
      <span class="notification-header-title">
        <i class="fa-sharp fa-solid fa-bell"></i> Notifications</span>
    <div (click)="closePopup()" class="notification-header-exit"><i class="fas fa-times"></i></div>
  </div>
  <div class="notification-list">
    <app-notification-list [@openClose]="notificationListOpen ? 'open' : 'closed'" (closeNotificationPopup)="closePopup()"></app-notification-list>
  </div>
  <div class="action-buttons" *ngIf="shouldShowDismiss">
    <button (click)="dismissAllNotifications()">Dismiss all</button>
  </div>
</div>

<div class="modal" [class.modalActive]="notificationListOpen" (click)="closePopup()"></div>

